import "../pages.scss"
import { MarcasState } from '../../context/marcas/MarcasState';
import Datatable from "./marcasTable/Datatable"

const MarcasPage = () => {
  return (
    <>
      <MarcasState>
        <Datatable />
      </MarcasState>

    </>
  )
}

export default MarcasPage